import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  pnfSection: {
    backgroundColor: "rgb(var(--silver))",
    minHeight: "100dvh",
    "& .pnfInner": {
      padding: "16px",
      borderRadius: "8px",
      border: "1px solid rgb(var(--light))",
      boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
      "& .pnfIcn": {
        position: "relative",
        width: "110px",
        height: "110px",
        marginBottom: "28px",
        flexShrink: "0",
        "& .pnfIRing": {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          border: "1.5px solid rgb(var(--brand__primary) / 0.4)",
          animation: "ripple 4s ease-in-out infinite",
          "&:nth-child(1)": {
            width: "100px",
            height: "100px",
            animationDelay: "0s",
          },
          "&:nth-child(2)": {
            width: "90px",
            height: "90px",
            animationDelay: "0.3s",
          },
          "&:nth-child(3)": {
            width: "70px",
            height: "70px",
            animationDelay: "0.4s",
          },
        },
        "& .pnfIBg": {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "60px",
          height: "60px",
          background: "rgb(var(--brand__primary))",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
      },
      "& .sing": {
        fontSize: "100px",
        fontWeight: "700",
        color: "rgb(var(--brand__primary) / 0.1)",
        position: "absolute",
        right: "10px",
        bottom: "-10px",
        lineHeight: "1",
        margin: "0",
        zIndex: "0",
      },
    },
  },
});
